<template>
  <div>
    <popover-right v-model="isShowRecognition" width="820px" :closed="closed">
      <h1 class="popover-right-title approve-dialog">认筹审批
        <div class="status-wrap">
          <i class="approve-round approve-round-1" :class="`approve-round-${info.approval && info.approval.check_status}`"></i>
          {{info.approval && info.approval.check_status_name || '--'}}
        </div>
        <div class="menus" v-if="info.pending && info.pending.is_allow_handle">
          <a class="cut-btn-primary cut-btn-aggree" @click="passClick">同意</a>
          <a class="cut-btn-primary" @click="isShowRefuse = true">拒绝</a>
        </div>
      </h1>
      <!-- 审批进度条 -->
      <div class="approve-steps clearfix">
        <div class="step active">
          <i class="round"></i>
          <p class="text">提交审批</p>
          <p class="flow-approve-name">{{info.approval && info.approval.admin_name}}</p>
        </div>
        <template v-if="info.flow && info.flow.nodes && info.flow.nodes.length > 0">
          <div class="step" v-for="(flow, key) in info.flow.nodes" :key="key" :class="flow.id <= info.flow.current_node && 'active'">
            <i class="round"></i>
            <p class="text">{{flow.name}}</p>
            <p class="flow-approve-name" v-if="!flow.is_handle && !!flow.handler_name">
              等待<span :title="flow.handler_name">{{flow.handler_name}}</span>处理
            </p>
            <p class="flow-approve-name" v-if="flow.is_handle && !!flow.handler_name">{{flow.handler_name}}已处理</p>
          </div>
        </template>
      </div>
      <!-- 审批详情 -->
      <div class="pover-right-con approve-dialog-detail">
        <p class="title">基本信息</p>
        <div class="form-list-info clearfix">
          <div class="item item-show">
            <span class="label">订单ID：</span>
            <p class="result">{{info.order && info.order.order_code || '--'}}</p>
          </div>
          <div class="item item-show">
            <span class="label">商机ID：</span>
            <p class="result">{{info.business && info.business.business_code || '--'}}</p>
          </div>
          <div class="item item-show">
            <span class="label">客户：</span>
            <p class="result">
              <span class="entery-name" @click="toCustomeDetail">{{info.customer && info.customer.name || '--'}}</span>
            </p>
          </div>
          <div class="item item-show">
            <span class="label">项目：</span>
            <p class="result">{{info.project && info.project.name || '--'}}</p>
          </div>
          <div class="item item-show">
            <span class="label">认筹金（元）：</span>
            <p class="result">{{info.voucher && info.voucher.recognition_amount || '--'}}</p>
          </div>
          <div class="item item-show">
            <span class="label">认筹日期：</span>
            <p class="result" v-analysis-time="info.voucher && info.voucher.recognition_time"></p>
          </div>
          <div class="item item-show">
            <span class="label">优惠确认函：</span>
            <p class="result">{{info.voucher && info.voucher.preferential_code || '--'}}</p>
          </div>
          <div class="item item-show">
            <span class="label">凭证：</span>
            <p class="result">
              <a class="look-at" @click="visible = true" v-if="info.attachment && info.attachment.length > 0">查看</a>
              <span v-else>--</span>
            </p>
          </div>
          <div class="item item-show approve-detail-remark">
            <span class="label">备注：</span>
            <p class="result">{{info.voucher && info.voucher.remark || '--'}}</p>
          </div>
        </div>
      </div>
      <!--  历史记录 -->
      <div class="pover-right-con approve-dialog-detail" v-if="info.log && info.log.length > 0">
        <p class="title">历史记录</p>
        <div class="history-record">
          <div class="record-item" v-for="(log, key) in info.log" :key="key">
            <div class="time">
              <span v-analysis-time="log.created_at"></span>
              <p>{{log.admin_name || '--'}}</p>
            </div>
            <p class="desc">{{log.content || '--'}}</p>
          </div>
        </div>
      </div>
    </popover-right>
    <!--  凭证轮播图 -->
    <swipe :dataList="data" v-model="visible" />
    <!-- 拒绝原因 -->
    <approve-refuse-modal v-model="isShowRefuse" @confirm="refuseEvent" />
  </div>
</template>
<script>
import PopoverRight from '@/components/popover/index';
import Swipe from '@/components/swipe/index';
import {getApproveRecognitionDetail, passApprove, refuseApprove} from '@/api/approve';
import defaultSetting from '@/setting/index';
import ApproveRefuseModal from '@/components/refuseModal';
import { getDetailPermission } from '@/api/custome';
export default {
  name: 'ApproveRecognitionDialog',
  components: {
    PopoverRight,
    Swipe,
    ApproveRefuseModal
  },
  props: {
    approvalId: Number,
    emitName: String
  },
  data () {
    return {
      info: {},
      isShowRecognition: false,
      data: [],
      visible: false,
      info: {},
      isShowRefuse: false
    }
  },
  mounted () {
    this.initDetail();
    this.$nextTick(() => {
      this.isShowRecognition = true;
    })
  },
  methods: {
    async toCustomeDetail (id) {
      try {
        await getDetailPermission(this.info.customer.id);
        this.$EventBus.$emit(this.emitName, {category: 'customerDetail', params: {
          customerId: this.info.customer.id
        }}); 
      } catch (error) {
        console.log(error)
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    closed () {
      this.isShowRecognition = false;
      this.info = {};
      this.visible = false;
      this.$emit('input', '');
    },
    async initDetail () {
      try {
        const res = await getApproveRecognitionDetail(this.approvalId, {
        });
        this.info = res;
        if (res.attachment && res.attachment.length > 0) {
          this.data = res.attachment.map(v => defaultSetting.sourceUrl + v.path)
        }
      } catch (error) {
        this.$message.error(error.msg || '获取审批详情出现错误');
      }
    },
    async refuseEvent (remark) {
      try {
        await refuseApprove({
          pending_id: this.info.pending.id,
          remark
        });
        this.$message.success('审批拒绝操作成功');
        this.isShowRefuse = false;
        this.closed();
        this.$parent.initList && this.$parent.initList();
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请重试');
      }
    },
    async passClick () {
      this.$confirm('确认同意该申请审批？', '操作提示', {
        customClass: 'custom-delete-dialog'
      }).then(async _ => {
        try {
          let params = {
            pending_id : this.info.pending.id
          };
          await passApprove(params);
          this.$message.success('审批通过操作成功');
          this.closed();
          this.$parent.initList && this.$parent.initList();
        } catch (error) {
          this.$message.error(error.msg || '操作失败，请重试');
        }
      }).catch(e => {})
    }
  }
}
</script>
<style lang="less">
@import url('~@/assets/style/approve.less');
</style>
<style scoped lang="less">
.width-all{
  width: 100% !important;
  .result{
    overflow: initial !important;
    display: block !important;
    line-height: 25px !important;
  }
}
</style>
